import { useOutletContext } from 'react-router'
import { PhotosetFinal } from '@/features/photoset/components/photoset-final'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

export const PhotosetUnavailableQa = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const photosetQuery = useGetPhotoset(urlParams, { enabled: false })

	return (
		<PhotosetFinal
			isLoading={photosetQuery.isFetching}
			status='error'
			subtitle={
				photosetQuery.data?.reason_decline_id
					? t('photoset:unavailable_qa.subtitle_rejected')
					: t('photoset:unavailable_qa.subtitle_editing')
			}
			title={t('photoset:unavailable_qa.title')}
		/>
	)
}
